import { axiosClient } from './axiosClient';

const auditService = {
  /**
   * Récupérer tous les logs d'audit avec filtres
   * @param {Object} params - Paramètres de filtrage
   * @param {string} params.action - Filtrer par type d'action
   * @param {number} params.user - Filtrer par ID utilisateur
   * @param {number} params.salon_id - Filtrer par ID salon
   * @param {string} params.search - Recherche dans description, email, nom
   * @param {number} params.page - Numéro de page
   * @param {number} params.page_size - Nombre d'éléments par page
   */
  getLogs: (params = {}) => {
    return axiosClient.get('/audit/logs/', { params });
  },

  /**
   * Récupérer un log spécifique
   * @param {number} id - ID du log
   */
  getLog: (id) => {
    return axiosClient.get(`/audit/logs/${id}/`);
  },

  /**
   * Récupérer les logs d'un utilisateur spécifique
   * @param {number} userId - ID de l'utilisateur
   * @param {Object} params - Paramètres additionnels
   */
  getUserLogs: (userId, params = {}) => {
    return axiosClient.get('/audit/logs/', {
      params: { ...params, user: userId },
    });
  },

  /**
   * Récupérer les logs d'un salon spécifique
   * @param {number} salonId - ID du salon
   * @param {Object} params - Paramètres additionnels
   */
  getSalonLogs: (salonId, params = {}) => {
    return axiosClient.get('/audit/logs/', {
      params: { ...params, salon_id: salonId },
    });
  },

  /**
   * Récupérer les logs par type d'action
   * @param {string} action - Type d'action (ex: 'user.password_reset')
   * @param {Object} params - Paramètres additionnels
   */
  getLogsByAction: (action, params = {}) => {
    return axiosClient.get('/audit/logs/', {
      params: { ...params, action },
    });
  },

  /**
   * Récupérer la dernière connexion d'un utilisateur
   * @param {number} userId - ID de l'utilisateur
   */
  getLastLogin: async (userId) => {
    try {
      const response = await axiosClient.get('/audit/logs/', {
        params: {
          user: userId,
          action: 'user.login',
          page_size: 1,
        },
      });
      return response.data.results?.[0] || null;
    } catch (error) {
      console.error('Error fetching last login:', error);
      return null;
    }
  },

  /**
   * Récupérer les actions récentes d'un utilisateur
   * @param {number} userId - ID de l'utilisateur
   * @param {number} limit - Nombre d'actions à récupérer
   */
  getRecentUserActions: (userId, limit = 10) => {
    return axiosClient.get('/audit/logs/', {
      params: {
        user: userId,
        page_size: limit,
      },
    });
  },

  /**
   * Récupérer les actions récentes sur un salon
   * @param {number} salonId - ID du salon
   * @param {number} limit - Nombre d'actions à récupérer
   */
  getRecentSalonActions: (salonId, limit = 20) => {
    return axiosClient.get('/audit/logs/', {
      params: {
        salon_id: salonId,
        page_size: limit,
      },
    });
  },

  /**
   * Récupérer les statistiques d'actions
   */
  getActionStats: async () => {
    try {
      const response = await axiosClient.get('/audit/logs/', {
        params: { page_size: 1000 },
      });
      const logs = response.data.results || [];
      
      // Compter les actions par type
      const actionCounts = {};
      logs.forEach((log) => {
        actionCounts[log.action] = (actionCounts[log.action] || 0) + 1;
      });
      
      return actionCounts;
    } catch (error) {
      console.error('Error fetching action stats:', error);
      return {};
    }
  },
};

export default auditService;
